/** @jsxImportSource theme-ui */
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";
import ShoppingCartButton from "../../Shop/ShoppingCartButton";
import ProductShopExternalButton, {
  afterQuery,
} from "./ProductShopExternalButton";

/** A shop button for an external online shop.*/
interface Product {
  producer?: { name?: string };
  shortName?: string;
  vintage?: string;
}

export default function ProductShopButton({
  product,
  ...rest
}: {
  product: Product;
  [key: string]: any;
}) {
  const onlineShop = afterQuery(product);
  if (!onlineShop) return <WineSearcherButton product={product} {...rest} />;
  return <ProductShopExternalButton product={product} {...rest} />;
}

function WineSearcherButton({
  product,
  ...rest
}: {
  product: Product;
  [key: string]: unknown;
}) {
  const wineSearcherUrl = `https://www.wine-searcher.com/find/${encodeURIComponent(
    `${product.producer?.name || ""} ${product.shortName || ""}`
  ).toLowerCase()}/${product.vintage || ""}`;
  return (
    <ShoppingCartButton
      href={wineSearcherUrl}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <Trans>Find on Wine Searcher</Trans>
    </ShoppingCartButton>
  );
}

export const fragment = graphql(`
  fragment bb_ProductShopButton on Bottlebooks_Product {
    ...bb_ProductShopExternalButton
  }
`);
